export default __webpack_public_path__ + "static/media/O0006.76b8d485.png";